import React, { useState } from 'react';
import { AiFillStar } from 'react-icons/ai';
import './hotelDescriptionTooltip.less';
import getImagePathFromName from '../../../utils/getImagePathFromName';

interface Props {
  address: string;
  country: { name: string };
  identifier: string;
  image: string[];
  name: string;
  type: 'Hotel';
  stars: number;
}

const HotelDescriptionTooltip: React.FC<Props> = ({
  address,
  country,
  identifier,
  image,
  name,
  type,
  stars,
}) => {
  const [loadingFailed, setLoadingFailed] = useState(false);

  return (
    <div className="hotel-description-tooltip-inner">
      <div
        className="image-wrapper"
        style={{ backgroundImage: '/assets/images/hotel-default.png' }}
      >
        {!loadingFailed && (
          <img src={getImagePathFromName(image[0])} onError={() => setLoadingFailed(true)} />
        )}
        {loadingFailed && (
          <img src={'/assets/images/hotel-default.png'} className="img" />
        )}
      </div>
      <div className="description-wrapper">
        <span className="name">
          {name}
          <div>
            {!!stars &&
              Array.from(Array(stars).keys()).map((item) => {
                return <AiFillStar key={item} color="#fdb923" size={20} />;
              })}
          </div>
        </span>
        <span className="description">{`${country?.name}, ${address}`}</span>
        {(image?.[1] || image?.[2]) && (
          <div className="footer-image-group">
            {image?.[1] && (
              <div className="image-wrapper small">
                <img src={getImagePathFromName(image[1])} />
              </div>
            )}
            {image?.[2] && (
              <div className="image-wrapper small">
                <img src={getImagePathFromName(image[2])} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default HotelDescriptionTooltip;
